// providerFields/FonadaFields.tsx
import React from "react";
import { Input } from "antd";

interface FonadaFieldsProps {
  credentials: any;
  onChange: (key: string, value: string) => void;
}

const FonadaFields: React.FC<FonadaFieldsProps> = ({
  credentials,
  onChange,
}) => {
  return (
    <div className="d-grid" style={{ gap: 10 }}>
      <div>
        <div className="d-flex align-items-center justify-content-between mb-1">
          <label className="form-label fw-semibold mb-0">
            API Key <span className="text-danger">*</span>
          </label>
        </div>
        <Input
          placeholder="API Key *"
          value={credentials.api_key || ""}
          onChange={(e) => onChange("api_key", e.target.value)}
        />
      </div>

      <div>
        <div className="d-flex align-items-center justify-content-between mb-1">
          <label className="form-label fw-semibold mb-0">
            API URL <span className="text-danger">*</span>
          </label>
        </div>
        <Input
          placeholder="API URL *"
          value={credentials.api_url || ""}
          onChange={(e) => onChange("api_url", e.target.value)}
        />
      </div>

      <div className="d-grid" style={{ gap: 8 }}>
        <div>
          <div className="d-flex align-items-center justify-content-between mb-1">
            <label className="form-label fw-semibold mb-0">
              App ID (optional)
            </label>
          </div>
          <Input
            placeholder="App ID (optional)"
            value={credentials.app_id || ""}
            onChange={(e) => onChange("app_id", e.target.value)}
          />
        </div>

        <div>
          <div className="d-flex align-items-center justify-content-between mb-1">
            <label className="form-label fw-semibold mb-0">
              WABA ID (optional)
            </label>
          </div>
          <Input
            placeholder="WABA ID (optional)"
            value={credentials.waba_id || ""}
            onChange={(e) => onChange("waba_id", e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default FonadaFields;
